import { BaseClient } from '../client';

export type AdminUsuarioLista = {
	id: number;
	nome: string;
	email: string;
	perfil: string;
	status: string;
};

export type AdminUsuarioTotais = {
	qtd_ativo: number;
	qtd_inativo: number;
	qtd_recusado: number;
};

interface ApiResponse<T> {
	success: boolean;
	message: string;
	data: T;
}

export const getAdminUsersList = async (email?: string, status?: string, idRevenda?: string) => {
	const params: Record<string, string> = {};
	if (email?.trim()) params.email = email.trim();
	if (status?.trim()) params.status = status.trim();
	if (idRevenda?.trim()) params.idRevenda = idRevenda.trim();

	const response = await BaseClient.get<ApiResponse<AdminUsuarioLista[]>>('/Admin/User/Get/UsersAdmin', {
		params,
	});

	return response.data.data ?? [];
};

export const getAdminUsersTotals = async () => {
	const response = await BaseClient.get<ApiResponse<AdminUsuarioTotais>>('/Admin/User/Get/UsersAdmin/Totais');

	return response.data.data;
};
